<div class="mb-3" [class.has-error]="showError">
  <label *ngIf="props.label && props.hideLabel !== true" [attr.for]="id" class="label">
    {{ props.label }}:
    <span *ngIf="props.required && props.hideRequiredMarker !== true">*</span>
  </label>
  <div>
    <div style="display: flex;  flex-wrap: wrap;">
      <div *ngFor="let option of props.options; let i = index;">
        <nb-checkbox [id]="id + '_' + i"
                     [checked]="isChecked(option)"

                     [formlyAttributes]="field" (checkedChange)="onChange(option.value, $event)">
          {{ option.label }}  ({{ (option.count > 0) ? option.count : 0 }})
        </nb-checkbox>
      </div>
    </div>
  </div>
  <div *ngIf="showError" class="invalid-feedback">
    <formly-validation-message [field]="field"></formly-validation-message>
  </div>
  <small *ngIf="props.description" class="form-text text-muted">{{ props.description }}</small>
</div>
